$(document).ready(function () {

  var wrapperSelector = ".countries-wrapper";

  if ($(wrapperSelector).length > 0) {
    const jqWrapper = $(wrapperSelector);
    const wrapper = document.querySelector(wrapperSelector);
    const countries = jqWrapper.data('countries');

    var vw = window.innerWidth;
    var vh = wrapper.offsetHeight;

    let elementSize = calculateElementSize();

    var bubbles = [];
    var pad = 4;
    var minWidth = elementSize;
    var maxWidth = elementSize;
    var bubbleHeight = elementSize;
    var elastic = Elastic.easeOut.config(0.3, 0.3);

    resize();
    window.addEventListener("resize", resize);

    function getInitialWrapperHeight() {
      const vh = window.innerHeight;
      const vw = window.innerWidth;
      return (1.2 * vh - 0.2 * vw);
    }

    function tryPlaceBubbleWithLimit(bubble, maxAttempts = 300) {
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        bubble.width = randomInt(minWidth, maxWidth);
        bubble.height = bubbleHeight;
        bubble.left = randomInt(pad, vw - (bubble.width + pad));
        bubble.top = randomInt(pad, parseInt(wrapper.style.height) - (bubble.height + pad));
        bubble.right = bubble.left + bubble.width;
        bubble.bottom = bubble.top + bubble.height;

        let hasCollision = false;
        for (let i = 0; i < bubbles.length; i++) {
          const b = bubbles[i];
          if (b === bubble || !b.placed) continue;
          if (intersects(bubble, b)) {
            hasCollision = true;
            break;
          }
        }

        if (!hasCollision) {
          bubble.placed = true;
          animateBubble(bubble);

          if (bubble.bottom > maxBottom) {
            maxBottom = bubble.bottom;
          }

          return true;
        }
      }

      return false; // failed to place after maxAttempts
    }

    function placeBubble(bubble, attempt = 0) {
      const MAX_ATTEMPTS = 500;

      if (attempt > MAX_ATTEMPTS) {
        console.warn("Resizing down – too many placement failures.");
        elementSize *= 0.9; // Shrink bubble size
        minWidth = maxWidth = elementSize;
        bubble.width = minWidth;
        bubble.height = bubbleHeight = minWidth;

        bubbles.forEach(b => {
          b.placed = false;
        });

        wrapper.innerHTML = "";
        bubbles = [];

        for (let i = 0; i < countries.length; i++) {
          const newBubble = createBubble(countries[i]);
          bubbles.push(newBubble);
          placeBubble(newBubble);
        }

        return;
      }

      bubble.placed = true;
      bubble.width = randomInt(minWidth, maxWidth);
      bubble.height = bubbleHeight;
      bubble.left = randomInt(pad, vw - (bubble.width + pad));
      bubble.top = randomInt(pad, vh - (bubble.height + pad));
      bubble.right = bubble.left + bubble.width;
      bubble.bottom = bubble.top + bubble.height;

      for (let i = 0; i < bubbles.length; i++) {
        const b = bubbles[i];
        if (b === bubble || !b.placed) continue;
        if (intersects(bubble, b)) {
          bubble.placed = false;
          break;
        }
      }

      if (bubble.placed) {
        animateBubble(bubble);
      } else {
        requestAnimationFrame(() => placeBubble(bubble, attempt + 1));
      }
    }

    function animateBubble(bubble) {

      TweenLite.set(bubble.element, {
        width: bubble.width,
        x: bubble.left,
        y: vh
      });

      var tl = new TimelineLite()
        .to(bubble.element, random(0.5, 2), { autoAlpha: 1, y: bubble.top, ease: elastic })
    }

    function createBubble(data) {

      var element = document.createElement("div");
      wrapper.appendChild(element);
      element.className = "bubble";
      element.style.height = bubbleHeight + "px";

      var text1 = document.createElement("div");
      text1.className = "text1";
      var title = document.createElement("h4");
      title.className = "text1-title";
      title.textContent = data.title;
      text1.appendChild(title)
      var subtitle = document.createElement("p");
      subtitle.textContent = data.subtitle;
      text1.appendChild(subtitle)

      var text2 = document.createElement("div");
      text2.className = "text2";
      var image = document.createElement("img");
      image.setAttribute('src', data.image.url)
      var country = document.createElement("p");
      country.className = "text2-country";
      country.textContent = data.country;
      var employees = document.createElement("p");
      employees.className = "text2-employees";
      employees.textContent = data.employees + " Mitarbeitende";
      var button = document.createElement("a");
      button.className = "btn";
      button.textContent = "Mehr zum Land";
      text2.appendChild(image)
      text2.appendChild(country)
      text2.appendChild(employees)
      //text2.appendChild(button)


      element.appendChild(text1)
      element.appendChild(text2)

      return {
        element: element,
        placed: false,
        width: minWidth,
        height: bubbleHeight,
        left: 0,
        top: 0,
        right: minWidth,
        bottom: bubbleHeight
      };
    }

    function intersects(a, b) {
      return !(b.left > a.right + pad ||
              b.right < a.left - pad ||
              b.top > a.bottom + pad ||
              b.bottom < a.top - pad);
    }

    function resize() {
      vw = window.innerWidth;
      wrapper.style.height = "auto";
      elementSize = 200; // your minimum target bubble size
      minWidth = maxWidth = elementSize;
      bubbleHeight = elementSize;

      let wrapperHeight = getInitialWrapperHeight();
      const MAX_HEIGHT = 5000;
      let success = false;

      function tryLayout() {
        maxBottom = 0;
        wrapper.innerHTML = "";
        wrapper.style.height = wrapperHeight + "px";

        bubbles = [];

        let failed = false;

        for (let i = 0; i < countries.length; i++) {
          const bubble = createBubble(countries[i]);
          bubbles.push(bubble);
          let placed = tryPlaceBubbleWithLimit(bubble, 300);
          if (!placed) {
            failed = true;
            break;
          }
        }

        if (failed && wrapperHeight < MAX_HEIGHT) {
          wrapperHeight += 200; // increase space and try again
          requestAnimationFrame(tryLayout);
        } else {
          // success or limit hit
          wrapper.style.height = (maxBottom + pad) + "px";
        }
      }

      tryLayout();
    }

    function random(min, max) {
      if (max == null) { max = min; min = 0; }
      if (min > max) { var tmp = min; min = max; max = tmp; }
      return min + (max - min) * Math.random();
    }

    function randomInt(min, max) {
      if (max == null) { max = min; min = 0; }
      if (min > max) { var tmp = min; min = max; max = tmp; }
      return Math.floor(min + (max - min + 1) * Math.random());
    }

    function calculateElementSize() {
      const defaultMaxSize = parseInt(jqWrapper.data("max-size")) || 200;
      const defaultMinSize = parseInt(jqWrapper.data("min-size")) || 50;
      const padding = 8;

      // Area available
      const areaAvailable = vw * vh;

      // Estimated area per bubble (with padding)
      const areaPerBubble = areaAvailable / countries.length;
      const estimatedSize = Math.sqrt(areaPerBubble) - padding;

      // Clamp between min and max
      return Math.max(defaultMinSize, Math.min(defaultMaxSize, estimatedSize));
    }
  }

});
